import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { fetchAllPostPromisedData } from '../../../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../../../common/constant';
import { ReactComponent as InfoIcon } from "assets/img/svg/InfoCircle.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { getFormatedDate } from '../../../../../../unAssigned/concessionApproval/common';
import AButton from '../../../../../../common/form-fields-mui/AButton';
import ALoader from '../../../../../../common/a-loader';
import moment from 'moment';

export const isPastDate = date => moment(date).startOf('day').isBefore(moment().startOf('day'));

const PaymentModeChangeAlertDialog = ({
    confirmHandler,
    dialogInfo = {},
    setDialogInfo
}) => {

    const { isOpen, rowData , isApiCall} = dialogInfo;
    const {paymentTransactionId , paymentMode} = rowData;
    const [loading, setLoading] = useState(false);
    const [receiptsData, setReceiptsData] = useState([]);

    const closeDialog = () => setDialogInfo({isOpen : false , rowData : {}})

    const getAllReceiptsForTransactionId = async () => {
        try {
            setLoading(true);
            const { psid, applicationId, receiptId } = rowData;
            const reqObj = {
                psid,
                applicationId,
                paymentMode,
                paymentTransactionId,
                receiptId
            }

            const resp = await fetchAllPostPromisedData(endpoint.manageReceipts.paymentMode, reqObj);
            if (resp?.code === 200) {
                setReceiptsData(resp?.data);
                if (!resp?.data?.length) {
                    confirmHandler(rowData);
                    closeDialog();
                }else{
                    setDialogInfo(prev=>({...prev, isOpen:true}))
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }

    const isAnyReceiptStale = () => receiptsData.some(receipt => isPastDate(receipt?.receiptDate));

    useEffect(() => {
        isApiCall && getAllReceiptsForTransactionId();
    }, [isApiCall])

    return (
        <Dialog
            open={isOpen}
        >
            <div className='d-flex flex-column p-3'>

                {loading && <ALoader position="fixed" />}

                <div className='d-flex justify-content-between'>
                    <InfoIcon />
                    <h2>Payment Mode Change Alert - {paymentTransactionId}</h2>
                    <CrossIcon onClick={closeDialog} />
                </div>

                <h4>Changing the payment mode for this receipt will update the payment mode for all associated receipts linked to this Transaction ID</h4>

                <table className='text-center'>
                    <thead>
                        <tr>
                            <th>Receipt Number</th>
                            <th>Receipt Date</th>
                            <th>Payment mode</th>
                        </tr>
                    </thead>
                    <tbody>
                        {receiptsData?.map(({ receiptId, receiptDate }) =>
                            <tr className={`${isPastDate(receiptDate) ? "text-danger" : ""}`} key={receiptId}>
                                <td>{receiptId}</td>
                                <td>{getFormatedDate(receiptDate)}</td>
                                <td>{paymentMode}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div className='mt-2'>
                    <AButton
                        variant='outline'
                        outlineVariantColor='#C0C0C0'
                        className='no-ml-btn'
                        onClick={closeDialog}
                    >
                        Go Back
                    </AButton>

                    <AButton
                        variant='primary_filled'
                        onClick={() => {
                            confirmHandler(rowData);
                            closeDialog();
                        }}
                        disabled={isAnyReceiptStale()}
                    >
                        Confirm
                    </AButton>

                </div>


            </div>

        </Dialog>
    );
}

export default PaymentModeChangeAlertDialog;